import React from 'react';

const BillingAddressForm = ({
    billingAddress,
    setBillingAddress,
    useSameAsShipping,
    setUseSameAsShipping,
    errors,
    usStates
}) => {
    return (
        <div style={{ marginTop: '2rem' }}>
            <h3>Billing Address</h3>

            <div className="form-group">
                <label className="form-label">
                    <input
                        type="checkbox"
                        checked={useSameAsShipping}
                        onChange={(e) => setUseSameAsShipping(e.target.checked)}
                        style={{ marginRight: '0.5rem' }}
                    />
                    Use same address as shipping
                </label>
            </div>

            {!useSameAsShipping && (
                <div className="form-grid" style={{ marginTop: '1rem' }}>
                    <div className="form-row-2">
                        <div className="form-group">
                            <label className="form-label">
                                First Name *
                            </label>
                            <input
                                type="text"
                                placeholder="Enter first name"
                                value={billingAddress.firstname}
                                onChange={(e) => setBillingAddress(prev => ({ ...prev, firstname: e.target.value }))}
                                required={!useSameAsShipping}
                                className={`form-input ${errors.billing_firstname ? 'error' : ''}`}
                            />
                            {errors.billing_firstname && (
                                <div className="form-error">
                                    {errors.billing_firstname}
                                </div>
                            )}
                        </div>
                        <div className="form-group">
                            <label className="form-label">
                                Last Name *
                            </label>
                            <input
                                type="text"
                                placeholder="Enter last name"
                                value={billingAddress.lastname}
                                onChange={(e) => setBillingAddress(prev => ({ ...prev, lastname: e.target.value }))}
                                required={!useSameAsShipping}
                                className={`form-input ${errors.billing_lastname ? 'error' : ''}`}
                            />
                            {errors.billing_lastname && (
                                <div className="form-error">
                                    {errors.billing_lastname}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            Street Address *
                        </label>
                        <input
                            type="text"
                            placeholder="Enter street address"
                            value={billingAddress.street[0]}
                            onChange={(e) => setBillingAddress(prev => ({ ...prev, street: [e.target.value] }))}
                            required={!useSameAsShipping}
                            className={`form-input ${errors.billing_street ? 'error' : ''}`}
                        />
                        {errors.billing_street && (
                            <div className="form-error">
                                {errors.billing_street}
                            </div>
                        )}
                    </div>

                    <div className="form-row-3">
                        <div className="form-group">
                            <label className="form-label">
                                City *
                            </label>
                            <input
                                type="text"
                                placeholder="Enter city"
                                value={billingAddress.city}
                                onChange={(e) => setBillingAddress(prev => ({ ...prev, city: e.target.value }))}
                                required={!useSameAsShipping}
                                className={`form-input ${errors.billing_city ? 'error' : ''}`}
                            />
                            {errors.billing_city && (
                                <div className="form-error">
                                    {errors.billing_city}
                                </div>
                            )}
                        </div>
                        <div className="form-group">
                            <label className="form-label">
                                State *
                            </label>
                            <select
                                value={billingAddress.region_id || ''}
                                onChange={(e) => {
                                    const selectedOption = e.target.options[e.target.selectedIndex];
                                    setBillingAddress(prev => ({
                                        ...prev,
                                        region_id: parseInt(e.target.value),
                                        region: selectedOption.text
                                    }));
                                }}
                                required={!useSameAsShipping}
                                className={`form-select ${errors.billing_region ? 'error' : ''}`}
                            >
                                <option value="">Select State</option>
                                {usStates.map((state) => (
                                    <option key={state.id} value={state.id}>
                                        {state.name}
                                    </option>
                                ))}
                            </select>
                            {errors.billing_region && (
                                <div className="form-error">
                                    {errors.billing_region}
                                </div>
                            )}
                        </div>
                        <div className="form-group">
                            <label className="form-label">
                                ZIP Code *
                            </label>
                            <input
                                type="text"
                                placeholder="Enter ZIP code"
                                value={billingAddress.postcode}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/[^\d-]/g, '');
                                    setBillingAddress(prev => ({ ...prev, postcode: value }));
                                }}
                                required={!useSameAsShipping}
                                className={`form-input ${errors.billing_postcode ? 'error' : ''}`}
                            />
                            {errors.billing_postcode && (
                                <div className="form-error">
                                    {errors.billing_postcode}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            Phone Number *
                        </label>
                        <input
                            type="tel"
                            placeholder="Enter phone number"
                            value={billingAddress.telephone}
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^\d]/g, '');
                                setBillingAddress(prev => ({ ...prev, telephone: value }));
                            }}
                            required={!useSameAsShipping}
                            className={`form-input ${errors.billing_telephone ? 'error' : ''}`}
                        />
                        {errors.billing_telephone && (
                            <div className="form-error">
                                {errors.billing_telephone}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default BillingAddressForm;